import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppRequestHeadersService, OPERATION_ID_HEADER } from '../service/app-request-headers.service';
import { APP_VERSION_OUTDATED_STATUS, AppVersionReloadService } from '../service/app-version-reload.service';

@Injectable()
export class AppRequestHeadersInterceptor implements HttpInterceptor {

  private readonly _headers = inject(AppRequestHeadersService);
  private readonly _versionReload = inject(AppVersionReloadService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this._headers.isApiUrl(request.url)) {
      return next.handle(request);
    }
    const setHeaders = this._headers.build(request.method, request.headers.get(OPERATION_ID_HEADER));
    return next.handle(request.clone({ setHeaders })).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error?.status === APP_VERSION_OUTDATED_STATUS) {
          this._versionReload.handleOutdated();
        }
        return throwError(() => error);
      })
    );
  }
}
